import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import { EntryIcon, ExitIcon, ContractTypesIcon } from "@icarius-icons/";
import { getLocalizedString } from "@icarius-localization/strings";

const Index = () => {

  const data = [
    {
      name: getLocalizedString("entryTypes"),
      icon: <EntryIcon />,
      path: paths.entryTypes,
    },
    {
      name: getLocalizedString("exitTypes"),
      icon: <ExitIcon />,
      path: paths.exitTypes,
    },
    {
      name: getLocalizedString("contractTypes"),
      icon: <ContractTypesIcon />,
      path: paths.contractTypesSettings,
    }
  ];

  return (
    <ScreenSelector
      title={getLocalizedString("entryExitTypes")}
      data={data}
    />
  );
}

export default Index;
